import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import Notifications from "./notifications";

const pageSize = 50;

const NotificationsController = async ({ req, res, load, locals }) => {
  const { query = {} } = req;
  const { page = 0, sort = "newest", type = "all", status = "all" } = query;

  await load("coachNotifications", {
    limit: pageSize,
    skip: pageSize * page,
    sort: { date: sort === "newest" ? -1 : 1 },
    type: type === "all" ? undefined : type,
    read: status === "all" ? undefined : status === "read" ? true : false,
  });

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = <Notifications />;
};

export default NotificationsController;
